import type { User } from '@beacon/core';
import type {
  UserCreateInput,
  UserUpdateInput,
} from '@beacon/core/validation';

import type { BeaconClient } from '../client.js';

export interface UserListResponse {
  users: User[];
}

export interface AdminUserRow extends User {
  organizationName: string;
  organizationType: 'client' | 'internal';
}

export interface AdminUserListResponse {
  users: AdminUserRow[];
}

export const usersApi = {
  /** Conduct staff users available for ticket assignment. */
  listAssignable(client: BeaconClient): Promise<UserListResponse> {
    return client.get<UserListResponse>('/api/users/assignable');
  },

  /** Full user list with their orgs joined — admin surface. */
  listAdmin(client: BeaconClient): Promise<AdminUserListResponse> {
    return client.get<AdminUserListResponse>('/api/users');
  },

  create(
    client: BeaconClient,
    input: UserCreateInput
  ): Promise<{ id: string }> {
    return client.post<{ id: string }>('/api/users', input);
  },

  update(
    client: BeaconClient,
    id: string,
    input: UserUpdateInput
  ): Promise<User> {
    return client.patch<User>(`/api/users/${encodeURIComponent(id)}`, input);
  },
};
